var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_386_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.001,
    height: 45.117,
    viewBox: "0 0 47.001 45.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_389_",
    d: "M46.911,34.992A18.529,18.529,0,0,0,32.5,18.744V16.412a3.121,3.121,0,0,0-.753-6.15h-6.61a3.121,3.121,0,0,0-.753,6.15v2.339a18.433,18.433,0,0,0-9.04,4.973,18.632,18.632,0,0,0-1.559,1.769c-.023,0-.046,0-.07,0H7.176a.918.918,0,1,0,0,1.836h5.362a18.4,18.4,0,0,0-1.629,3.528H.918a.918.918,0,0,0,0,1.836H10.39a18.665,18.665,0,0,0-.456,3.529H5.875a.918.918,0,1,0,0,1.836H9.964a18.638,18.638,0,0,0,.573,3.529H4.59a.918.918,0,0,0,0,1.836h6.533a18.541,18.541,0,0,0,15.5,11.871q.91.09,1.819.09a18.588,18.588,0,0,0,10.12-2.991.918.918,0,1,0-1-1.539,16.708,16.708,0,1,1,4.921-4.927.918.918,0,1,0,1.54,1A18.6,18.6,0,0,0,46.911,34.992ZM23.854,13.383A1.287,1.287,0,0,1,25.139,12.1h6.61a1.285,1.285,0,1,1,0,2.57h-6.61A1.287,1.287,0,0,1,23.854,13.383Zm2.368,5.052V16.5h4.444v1.928A18.7,18.7,0,0,0,26.222,18.435Z",
    transform: "translate(0 -10.262)",
    fill: "#fe4e4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_391_",
    d: "M436.688,425.5a.918.918,0,1,0,.649.269A.923.923,0,0,0,436.688,425.5Z",
    transform: "translate(-395.766 -387.381)",
    fill: "#fe4e4e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_394_",
    d: "M169.113,144.609a14.241,14.241,0,1,0,14.241,14.241A14.257,14.257,0,0,0,169.113,144.609Zm0,26.646a12.4,12.4,0,1,1,12.4-12.4A12.419,12.419,0,0,1,169.113,171.255Z",
    transform: "translate(-140.655 -132.276)",
    fill: "#fe4e4e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_397_",
    d: "M267.705,219.68l-4.547,4.547a2.845,2.845,0,0,0-2.52,0l-2.035-2.035a.918.918,0,0,0-1.3,1.3l2.035,2.035a2.853,2.853,0,1,0,5.117,0l4.413-4.413h0l.133-.133a.918.918,0,0,0-1.3-1.3ZM261.9,227.8a1.017,1.017,0,1,1,1.017-1.017A1.018,1.018,0,0,1,261.9,227.8Z",
    transform: "translate(-233.44 -200.211)",
    fill: "#fe4e4e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_398_",
    d: "M399.424,289.86h-.851a.918.918,0,0,0,0,1.836h.851a.918.918,0,1,0,0-1.836Z",
    transform: "translate(-361.15 -264.193)",
    fill: "#fe4e4e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_399_",
    d: "M194.85,289.616H194a.918.918,0,1,0,0,1.836h.85a.918.918,0,1,0,0-1.836Z",
    transform: "translate(-175.357 -263.971)",
    fill: "#fe4e4e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    d: "M301.041,185.505a.918.918,0,0,0,.918-.918v-.85a.918.918,0,1,0-1.836,0v.85A.918.918,0,0,0,301.041,185.505Z",
    transform: "translate(-272.572 -166.978)",
    fill: "#fe4e4e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_424_",
    d: "M300.8,387.393a.918.918,0,0,0-.918.918v.85a.918.918,0,0,0,1.836,0v-.85A.918.918,0,0,0,300.8,387.393Z",
    transform: "translate(-272.35 -352.772)",
    fill: "#fe4e4e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_425_",
    d: "M.918,351.44a.918.918,0,1,0,.649,1.567.918.918,0,0,0-.649-1.567Z",
    transform: "translate(0 -320.12)",
    fill: "#fe4e4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.1a202e335f395406cdd7954089256cae.svg";
export { ForwardRef as ReactComponent };